import React, { useEffect, useRef }  from "react";
import { Row, Col, Card } from "antd";
import "../../assets/css/agenda.css";

const Schendule = () => {
  const cardsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.2 }
    );

    cardsRef.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const conferencia = [
    {
      hora: "08:00 h",
      titulo: "Registro",
      desc: null,
    },
    {
      hora: "09:00 h",
      titulo:
        "Inauguración y bienvenida - Director General y Agentes Aduanales de CASADUANA",
      desc: null,
    },
    {
      hora: "09:30 h",
      titulo:
        'Panel 1 - "Tendencias de fiscalización a las operaciones de comercio exterior"',
      desc: (
        <>
          <i>Panelistas:</i> <br />
          Georgina Estrada Aguirre – Presidenta de la Asociación de Mujeres Aduaneras
          <br />
          Fernando Mejía - Director General de Casaduana
          <br />
          <br />
          <i>Moderador:</i> <br />
          Brenda Ángeles – Gerente Jurídico de CASADUANA
        </>
      ),
    },
    {
      hora: "10:30 h",
      titulo:
        'Panel 2 - "Ley Aduanera: El OEA como respuesta a los nuevos desafíos globales"',
      desc: (
        <>
          <i>Panelistas:</i> <br />
          Irving Becerril Zamora – Especialista en cadena de suministros
          <br />
          Pablo Mejía González – Agente Aduanal
          <br />
          <br />
          <i>Moderador:</i> <br />
          Brenda Ángeles – Gerente Jurídico de CASADUANA
        </>
      ),
    },
    {
      hora: "11:15 h",
      titulo: "Receso - Coffee Break",
      desc: null,
    },
    {
      hora: "11:30 h",
      titulo:
        'Panel 3 - "Manifestación de Valor Electrónica: Materialidad y trazabilidad en las operaciones de comercio exterior"',
      desc: (
        <>
          <i>Panelista:</i> <br />
          Dr Mario Osorio, Director Adscrito a la Dirección General de Investigación Aduanera de la ANAM. <br />
          <br />
          <i>Moderador:</i> <br />
          Brenda Angeles Gerente Jurídico de CASADUANA<br />
          Pablo Mejía Agente Aduanal
        </>
      ),
    },
    {
      hora: "12:00 h",
      titulo:
        'Panel 4 - "Compliance aduanero, fiscal, contable y penal: factores decisivos para 2026"',
      desc: (
        <>
          <i>Panelistas:</i> <br />
          Brenda Ángeles – Gerente Jurídico de CASADUANA<br />
          Pablo Mejía – Agente Aduanal <br />
          Fernando Mejía – Director General
        </>
      ),
    },
    {
      hora: "12:40 h",
      titulo: "Dinámica con asistentes y entrega de premios",
      desc: null,
    },
    {
      hora: "12:50 h",
      titulo:
        "Clausura - Director General y Agentes Aduanales de CASADUANA",
      desc: null,
    },
  ];

  return (
    <Row className="agenda-wrapper" justify={'center'} style={{ padding: "60px 0" }}>
      <Col xs={22} md={16}>
        <h2 className="titulo_agenda" style={{ textAlign: "center" }}>
          Programa del evento
        </h2>

        <p
          style={{
            textAlign: "center",
            marginBottom: 40,
            fontSize: 18,
            color: "#1677ff",
          }}
        >
          23 de enero, 2026
        </p>

        {conferencia.map((item, i) => (
          <Card
  key={i}
  ref={(el) => (cardsRef.current[i] = el)}
  className="agenda-card"
  style={{
    marginBottom: 20,
    borderRadius: 12,
    padding: "18px 22px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
  }}
>
            <Row>
              <Col xs={24} md={4}>
                <p
                  style={{
                    fontWeight: 700,
                    fontSize: 18,
                    marginBottom: 10,
                    color: "#1677ff",
                  }}
                >
                  {item.hora}
                </p>
              </Col>

              <Col xs={24} md={20}>
                <p
                  style={{
                    fontSize: 17,
                    fontWeight: 600,
                    color: "#002b45",
                  }}
                >
                  {item.titulo}
                </p>

                {item.desc && (
                  <div style={{ marginTop: 8, opacity: 0.85 }}>{item.desc}</div>
                )}
              </Col>
            </Row>
          </Card>
        ))}
      </Col>
    </Row>
  );
};

export default Schendule;
